import React from 'react'
import PropTypes from 'prop-types'
import Fuse from 'fuse.js'
import './style.css'

import Dialog from 'material-ui/Dialog'
import FontAwesome from 'react-fontawesome'
import TextField from 'material-ui/TextField'
import StatusDisplay from 'components/StatusDisplay'
import ShowHide from 'components/ShowHide'

class AgendaSelectList extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            showSearchInput: false,
            searchTerm: '',
        }
        this.handleSearchToggle = this.handleSearchToggle.bind(this)
        this.handleSearchChange = this.handleSearchChange.bind(this)
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        // Clear search on dialog closing
        if (!nextProps.open) {
            this.setState({ showSearchInput: false, searchTerm: '' })
        }
    }

    handleSearchToggle() {
        const { showSearchInput } = this.state
        this.setState({ showSearchInput: !showSearchInput })
    }
    handleSearchChange(e, searchTerm) {
        this.setState({ searchTerm })
    }

    render() {
        const { agendas, open, onAgendaSelect, onRefreshAgendas, onClose, ui } = this.props
        const { showSearchInput, searchTerm } = this.state

        // Filter by search term and then sort by professional full name
        const a = searchTerm.length > 0 ? new Fuse(agendas, {
            shouldSort: true,
            findAllMatches: true,
            threshold: 0.5,
            keys: [
                'professional.fullName',
                'professional.dtoProfessionalSpecialties.specialtyName',
                'office.officeName'
            ]
        }).search(searchTerm) : agendas.sort((a1, a2) => a1.professional.fullName < a2.professional.fullName ? -1 : 1)

        return (
            <Dialog
                className="AgendaSelectList"
                open={open}
                contentStyle={{ maxWidth: 320 }}
                autoScrollBodyContent={true}
                onRequestClose={onClose}>

                <div>
                    <div className="AgendaSelectList_Controls">
                        <h4>Selecione uma Agenda</h4>
                        <FontAwesome name="search" onClick={this.handleSearchToggle} />
                        <FontAwesome name="refresh" onClick={onRefreshAgendas} />
                    </div>

                    <TextField name="search" className="AgendaSelectList_SearchInput"
                        style={{ display: showSearchInput ? 'block' : 'none' }}
                        value={searchTerm}
                        onChange={this.handleSearchChange}
                        hintText="Procurar Agendas"
                    />

                    <StatusDisplay status={ui.agendas}>
                        Houve um erro. Por favor tente recarregar a lista de agendas.
                    </StatusDisplay>

                    <ShowHide show={!ui.agendas.isLoading && a.length > 0}>
                        {a.map((a, i) => (
                            <div
                                className="AgendaOption"
                                onClick={onAgendaSelect.bind(null, a)}
                                key={i}>

                                <span>{a.professional.fullName}</span>
                                <small>{a.office.officeName}</small>
                                <ul>
                                    {a.professional.dtoProfessionalSpecialties.map(s => (
                                        <li key={s.specialtyId}>{s.specialtyName}</li>
                                    ))}
                                </ul>
                            </div>
                        ))}
                    </ShowHide>

                </div>
            </Dialog>
        )
    }
}


AgendaSelectList.propTypes = {
    agendas: PropTypes.array.isRequired,
    open: PropTypes.bool.isRequired,
    onAgendaSelect: PropTypes.func.isRequired,
    onRefreshAgendas: PropTypes.func.isRequired,
    onClose: PropTypes.func,
    ui: PropTypes.object.isRequired,
}

export default AgendaSelectList


// WEBPACK FOOTER //
// ./src/components/AgendaSelectList/index.js